import type {BaseActionableDocumentType} from 'app/general/types';
import type {BasicTeamSerializedType} from 'sweet-types';

export function getCommonDocument(document: BaseActionableDocumentType) {
  if (document.content_type === 'document') {
    return document.document;
  }
  return document;
}
export function excludeTeams(
  teams: Array<BasicTeamSerializedType>,
  toExclude: Array<BasicTeamSerializedType>
) {
  return teams.filter(
    (team) => !toExclude.find((excludedTeam) => excludedTeam?.url === team.url)
  );
}
